import type { ConversationMessage } from '../api/descriptionConversation';

export { conversationFor, type ConversationCheck } from '../api/descriptionConversation';

function fmtWhen(iso: string): string {
  return new Date(iso).toLocaleString(undefined, { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' });
}

/** The description a pre-application check started from and each refinement after it, latest last. */
export function DescriptionConversation({ messages, fallback }: { messages: ConversationMessage[]; fallback?: string | null }) {
  if (!messages.length) return fallback ? <p className="sx-proposal">{fallback}</p> : null;
  return (
    <ol className="sx-convo">
      {messages.map((m, i) => (
        <li key={m.id} className={`sx-convo-msg${i === messages.length - 1 ? ' sx-convo-latest' : ''}`}>
          <span className="sx-convo-meta">{i === 0 ? 'Description' : 'Refinement'} · {fmtWhen(m.at)}</span>
          <p className="sx-convo-text">{m.text}</p>
        </li>
      ))}
    </ol>
  );
}
